export default __webpack_public_path__ + "static/media/ubuntu.150dbd1c.svg";